/**
 * Created by HIWEIN008 on 2017/6/29.
 */
import Vue from 'vue'
import axios from 'axios'
class Means{
  //对连接地址参数的分析
  analysisURL(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return null;
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

//  时间转化为数字
  timeToNum(value) {
    switch (value) {
      case '上午':
        return 1;
        break;
      case '下午':
        return 2;
        break;
      case '晚上':
        return 3;
        break;
    }
  }

//数字转换为对应周期
  numToday(value) {
    if(value){
      value = value.toString();
      switch (value) {
        case '1':
          return '周一';
          break;
        case '2':
          return '周二';
          break;
        case '3':
          return '周三';
          break;
        case '4':
          return '周四';
          break;
        case '5':
          return '周五';
          break;
        case '6':
          return '周六';
          break;
        case '7':
          return '周日';
          break;
      }
    }
  }
  //周期转换为数字
  dayTonum(value) {
    value = value.toString();
    switch (value) {
      case '周一':
        return '1';
        break;
      case '周二':
        return '2';
        break;
      case '周三':
        return '3';
        break;
      case '周四':
        return '4';
        break;
      case '周五':
        return '5';
        break;
      case '周六':
        return '6';
        break;
      case '周日':
        return '7';
        break;
    }
  }


  //数字转化为上下午
  numTotime(value) {
    switch (value) {
      case '1':
        return '上午';
        break;
      case '2':
        return '下午';
        break;
      case '3':
        return '晚上';
        break;
    }
  }

  // 时间戳转时间
  timestampTotime(t) {
    if(t){
      let time = t.toString();
      if (time.length == 10) {
        time += '000';
      }
      time = new Date(parseInt(time)).toLocaleString().replace(/:\d{1,2}$/, ' ');
      time = time.replace(/GMT\+8/,'');
      return time;
    }
  }

  // 生成从当前日期开始的数组
  dayArr() {
    let currrentDay = parseInt((new Date()).getDay());
    // let currrentDay = 0;
    let arr = [];
    for (let i = currrentDay; i < 7; i++) {
      if (i == 0) {
        arr.push(7);
      } else {
        arr.push(i);
        if (i == 6) {
          i = -1;
        }
      }
      if (arr.length == 7) {
        break;
      }
    }
    return arr;
  }

  bubbleSort(arr){
    let len = arr.length;
    for (let i = 0; i < len; i++) {
      for (let j = 0; j < len - 1 - i; j++) {
        if (arr[j].newTime < arr[j+1].newTime) {
          var temp = arr[j+1];
          arr[j+1] = arr[j];
          arr[j] = temp;
        }
      }
    }
    return arr;
  }

  //通讯录颜色
  conColor(index){
    let result = (index+1)%7;
    switch (result){
      case 1 :
        return '#0067ED';
        break;
      case 2:
        return '#259ADE';
        break;
      case 3:
        return '#00A4FF';
        break;
      case 4:
        return '#12B7F5';
        break;
      case 5:
        return '#00C8DC';
        break;
      case 6:
        return '#2AD2C8';
        break;
      case 7:
        return '#0B92F7';
        break;
    }
  }


  routeReplace(route,string1,string2){
    let reg = new RegExp(string2);
    return route.replace(string1,string2);
  }

  //base64转blob
  BaseToBlob(v){
    if(v){
      var arr = v.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  }

 setCookie(c_name,value,expiredays){
    var exdate=new Date();
    exdate.setTime(Date.parse(exdate) + (parseInt(expiredays) * 24 * 60 * 60 * 1000));
    document.cookie=c_name+ "=" +escape(value)+((expiredays == undefined) ? "" : ";expires="+exdate.toGMTString());
  }
  getCookie(c_name) {
  if (document.cookie.length>0) {
   let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1) {
          c_start=c_start + c_name.length+1
          let c_end=document.cookie.indexOf(";",c_start);
          if (c_end==-1) c_end=document.cookie.length
          return unescape(document.cookie.substring(c_start,c_end))
        }
      }
      return ""
    }
    clearCookie(sKey, sPath, sDomain) {
      if (!sKey ) { return false; }
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
      return true;
    }
}
//连接有token主动抓token
const means = new Means();
let result = means.analysisURL('tokenData');
if (result){
  let result1 = JSON.parse(result);
  window.sessionStorage['token'] = result1.token;
  window.sessionStorage['refreshToken'] = result1.refreshToken;
  axios.defaults.headers.common['Authorization'] = window.btoa(unescape(encodeURIComponent(result1.token)));
  // console.log('存储token成功');
}


//删除数组中某个指定元素
Array.prototype.removeByValue = function(val) {
  let arr = [];
  for(var i=0; i<this.length; i++) {
    if(this[i] != val) {
      arr.push(this[i]);
    }
  }
  return arr;
}






export default means;



// WEBPACK FOOTER //
// ./src/means/means.js